"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3 4.706c0-.39.313-.706.7-.706h12.6c.387 0 .7.316.7.706s-.313.706-.7.706H3.7a.703.703 0 0 1-.7-.706m6.549 1.73a.695.695 0 0 1 .902 0l1.519 1.292a.71.71 0 0 1 .083.994.696.696 0 0 1-.986.084l-.367-.312v3.012l.367-.312a.696.696 0 0 1 .986.084.71.71 0 0 1-.083.995l-1.519 1.292a.695.695 0 0 1-.902 0L8.03 12.273a.71.71 0 0 1-.083-.995.696.696 0 0 1 .986-.084l.367.312V8.494l-.367.312a.696.696 0 0 1-.986-.084.71.71 0 0 1 .083-.994zM3 15.293c0-.39.313-.706.7-.706h12.6c.387 0 .7.316.7.706s-.313.706-.7.706H3.7a.703.703 0 0 1-.7-.706",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=CozyIcon20.js.map